import Vue from "vue";

Vue.component("ckeditor", () =>
  import("ckeditor4-vue").then(
    (m) => m.default?.component || m.component || m.default
  )
);
